import { TranslateService } from 'ng2-translate';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-error-payment',
  templateUrl: './modal-error-payment.component.html',
  styleUrls: ['./modal-error-payment.component.scss']
})
export class ModalErrorPaymentComponent implements OnInit {

  message;
  language= 'es';

  constructor(public dialogRef: MatDialogRef<ModalErrorPaymentComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private translate: TranslateService) {
    this.message = this.data.msjError;  
    this.language = localStorage.getItem('language');
    this.translate.use(this.language);
   }

  ngOnInit() {
  }



  onCloseCancel() {
    this.dialogRef.close();
  }
}
